import app from "js/legacy-app";

app.config(['featureFlagsProvider', function (featureFlagsProvider) {
    featureFlagsProvider.setInitialFlags([
        {
            key: "mechanicServices",
            active: true
        }
    ]);
}]);